<template>
    <div class="dashboard">
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="12" class="mb-24 text-right">
                
            </a-col>
            <a-col :span="12" class="mb-24 text-right">
                <a-button @click="openSearchOrderModal" icon="search" class="ml-15">
                    <i class="ni ni-archive-2 mr-5"></i> SEARCH ORDERS
				</a-button>
            </a-col>
        </a-row>
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="12" :lg="6">
                <waiting-time-card :waitingTime="waitingTime" :min="min" :max="max" @changed="handleWaitingTimeChanged"/>
            </a-col>
            <a-col :span="12" :lg="6">
                <capacity-card :capacity="capacity" :isEnalbed="isEnabled" @changed="handleCapacityChanged"/>
            </a-col>
            <a-col :span="12" :lg="6">
                <progress-card :progress="progress" v-if="isEnabled"/>
                <progress-card :progress="unmanagedProgress" v-else/>
            </a-col> 
            <a-col :span="12" :lg="6">
                <restaurant-state-card />
            </a-col>
        </a-row>
        <br/>
       
        <a-row :gutter="24" type="flex" align="stretch">
            <!-- <a-col :span="12" :lg="12">
                <order-manager-card :totalOrders="totalOrders"
                                    :inprogress="totalInprogressOrders"
                                    :pending="totalPendingOrders"
                                    :scheduled="totalScheduledOrders"
                                    :ready="totalReadyOrders"
                                    :dataLabels="openingHourLabels"
                                    :dataOrders="ordersByTime"
                />
            </a-col> -->
            <a-col :span="24" :lg="24">
                <orders-container />
            </a-col>
            
        </a-row>
        
        <!-- Orders Container -->

        <loading-modal ref="loadingModalRef"/>
        <search-order-modal ref="searchOrderModalRef" @viewOrderEvent="handleViewOrderEvent" @printOrderEvent="handlePrintOrderEvent"/>
        <order-detail-modal ref="orderModal"/>
        <payment-modal />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
//import { BARCODE_SCANNING_EVENT } from '../../common/events/eventsSource'
import { HUB_CONNECTING_EVENT, HUB_CONNECTED_EVENT, HUB_DISCONNECTED_EVENT } from '../../common/events/eventsSource'
import OrdersContainer from './orders/OrdersContainer.vue'
import WaitingTimeCard from '../../components/cards/WaitingTimeCard.vue'
import CapacityCard from '../../components/cards/CapacityCard.vue'
import ProgressCard from '../../components/cards/ProgressCard.vue'
import RestaurantStateCard from '../../components/cards/RestaurantStateCard.vue'
import OrderManagerCard from '../../components/cards/OrderManagerCard.vue'
import SearchOrderCard from '../../components/cards/SearchOrderCard.vue'
import OrderedByCard from '../../components/cards/OrderedByCard.vue'
import LoadingModal from '../../components/modals/LoadingModal.vue'
import ScanningMessageModal from '../../components/modals/ScanningMessageModal.vue'
import OrderDetailModal from '../../components/modals/OrderDetailModal.vue'
import SearchOrderModal from '../../components/modals/SearchOrderModal.vue'
import ScannerCard from '../../components/cards/ScannerCard.vue'
import PaymentModal from '../../components/modals/PaymentModal.vue'


export default {

    inject: ['eventBus'],

    components : {
        OrdersContainer,
        WaitingTimeCard,
        CapacityCard,
        ProgressCard,
        ScannerCard,
        SearchOrderCard,
        RestaurantStateCard,
        OrderManagerCard,
        SearchOrderCard,
        OrderedByCard,
        LoadingModal,
        ScanningMessageModal,
        OrderDetailModal,
        SearchOrderModal,
        PaymentModal

    },
    
    computed : {
        ...mapState({
            capacity : state => state.orderManager.orderManagerState.capacity,
            waitingTime : state => state.orderManager.orderManagerState.currentWaitingTime,
            min : state => state.orderManager.orderManagerState.minWaitingTime,
            max : state => state.orderManager.orderManagerState.maxWaitingTime,
            isEnabled : state => state.orderManager.orderManagerState.isEnabled,
        }),
        ...mapGetters({
            progress : 'orderManager/progress',
            unmanagedProgress : 'orderManager/unmanagedProgress',
            orderedByPhone : 'orderManager/orderedByPhone',
            orderedByWebApp : 'orderManager/orderedByWebApp',
            totalOrders : 'orderManager/totalOrders',
            totalInprogressOrders : 'orderManager/totalInprogressOrders',
            totalPendingOrders : 'orderManager/totalPendingOrders',
            totalScheduledOrders : 'orderManager/totalScheduledOrders',
            totalReadyOrders : 'orderManager/totalReadyOrders',
            openingHourLabels : 'openingHours/openingHourLabels',
            ordersByTime : 'orderManager/totalOrdersByTime'
        })
    },

    data () {
        return {
            isProcessing : false,
            currentOrder : null,
        }
    },

    methods : {
        
        handleViewOrderEvent(e) {
            this.$refs['orderModal'].show(e);
        },

        
        async handlePrintOrderEvent(e) {
            this.$message.loading('Sending data to server...', 0);
            let isSuccess = await this.$store.dispatch('orderManager/printOrderFromClientAction', e);
			if(!isSuccess) {
				this.$message.error('Something was wrong, please try again!', 5);
			}
			else {
				this.$message.success('The order will be printed after 30s!', 5);
			}
			this.$message.destroy();
        },

        openSearchOrderModal() {
            this.$refs['searchOrderModalRef'].show();
        },

       
        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },

        async handleWaitingTimeChanged(e) {
            console.log('waiting time changed : ' + e)
            this.$message.loading('Updating data...', 0);
            await this.$store.dispatch('orderManager/updateCurrentWaitingTimeAction', e);
            await this.sleep(1000);
            this.$message.destroy();
        },

        async handleCapacityChanged(e) {
            console.log('capacity changed : ' + e);
            this.$message.loading('Updating data...', 0);
            await this.$store.dispatch('orderManager/updateCapacityAction', e);
            await this.sleep(1000);
            this.$message.destroy();
        },


    },
    async created() {
        this.$message.loading('Loading data...', 0);
        await this.$store.dispatch('orderManager/getCurrentOrdersAction', {});
        await this.$store.dispatch('orderManager/getOrderManagerStateAction', {});
        await this.$store.dispatch('openingHours/getCurrentOpeningTimeAction', {});

        if (!this.$store.state.hub.isConnected) {
            this.eventBus.$emit(HUB_CONNECTING_EVENT, {});
        }

        await this.sleep(2000);
        this.$message.destroy(); 
    },
    destroyed() {
       
    }
}
</script>

<style scoped>

</style>